var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "introduce-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "img_wrap"
  }, _vm._l((_vm.imgList), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "wrap_top"
    }, [_c('div', {
      staticClass: "lf_wrap"
    }, [_c('img', {
      attrs: {
        "src": item.icon,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "flex-container"
    }, [_c('span', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.en))])])]), _vm._v(" "), _c('div', {
      staticClass: "rt_wrap"
    }, [_c('span', [_vm._v(_vm._s(item.desc))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.desc_en))])])]), _vm._v(" "), _c('img', {
      attrs: {
        "src": item.imgUrl,
        "alt": ""
      }
    })])
  }), 0)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "desc_wrap"
  }, [_c('span', {
    staticClass: "media_font_size_50"
  }, [_vm._v("筚路蓝缕七十载，扬帆奋楫开新局。1953年，中国汽车工业破土萌芽，中国人“造自己的汽 车”的愿望从梦想照进现实。七十载漫漫长路，中国汽车人沐风栉雨、披星戴月，建立起中国汽车 产业，取得了从零到壹的突破，实现了由小到大的发展，见证了中国汽车市场从不足500万的 年产销量，到达成1000万辆的梦想，再到2000万辆的飞跃，开启了汽车大国向汽车强国的新时代高质量发展之路。")]), _vm._v(" "), _c('span', {
    staticClass: "media_font_size_50"
  }, [_vm._v("当前世界之变、时代之变、历史之变正以前所未有的方式展开，中国汽车产业正处于国际化 加快高质量发展的关键时期。以“新科技”为核心的新能源汽车，作为中国汽车产业实现弯道超 车、从汽车大国迈向汽车强国的重要路径，已然成为业界共识。我国坚持纯电驱动战略取向，新 能源汽车产业发展取得了巨大成就，2015年以来产销量连续9年居世界首位。中国汽车在新能 源方面的先发优势正在从销量优势向技术优势转变，并逐渐引领世界新能源汽车产业变革新方向。")]), _vm._v(" "), _c('span', {
    staticClass: "media_font_size_50"
  }, [_vm._v("广州车展自2003年创办以来，始终秉承“新科技、新生活”的主题理念，以为汽车行业打造 高品质、国际化、综合性的展览体验平台为宗旨，与行业精英携手共进，砥砺前行，共同见证了中国汽车产业的发展与成长，参与了世界汽车工业的革新与重塑。第二十二届广州国际汽车展览会将于2024年11月15日至24日，在中国进出口商品交易会展馆盛大举办。我们诚邀全球车企共襄盛举，展示前沿新科技，共创美好新生活。")])])
}]
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d0f4bee","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/schedule/components/introduce.vue
// module id = null
// module chunks = 